import React, { useEffect, useRef, useState } from 'react';
import { DiaperVideo } from '../Product/WidgetsMergeCover/styled';
import { DiaperVideoContainer } from './styled';

const BabyDiaperVideo = ({ noMargin, videoUrl, aboutSection }) => {
  const videoRef = useRef();
  const [muteVideo, setMuteVideo] = useState(true);
  const [showIcon, setShowIcon] = useState(false);
  useEffect(() => {
    const video = videoRef.current;
    const videoSrc = video.dataset.src;

    const options = {
      root: null, // use the viewport
      rootMargin: '0px',
      threshold: 0.5, // 50% of the video is visible
    };

    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!video.getAttribute('src')) {
            video.setAttribute('src', videoSrc);
            video.load(); // Load the video
          }
          video.play(); // Autoplay when in viewport
        } else {
          video.pause(); // Pause when out of viewport
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(video);

    return () => {
      if (video) {
        observer.unobserve(video);
      }
    };
  }, []);
  return (
    <DiaperVideoContainer noMargin={noMargin}>
      <DiaperVideo
        ref={videoRef}
        playsInline
        data-src={videoUrl}
        autoPlay
        muted={muteVideo}
        loop
        noMargin={noMargin}
        onClick={() => {
          setMuteVideo((prev) => !prev);
          setShowIcon(true);
          setTimeout(() => {
            setShowIcon(false);
          }, 2000);
        }}
        aboutSection
      >
        <source src={videoUrl} type="video/mp4" />
      </DiaperVideo>
      {/* <div className="bottomOverlay"> */}
      <img
        src={
          muteVideo
            ? 'https://images.myloapp.in/NestJsUploads/1720528923685-Mute.webp'
            : 'https://images.myloapp.in/NestJsUploads/1720528923683-sound-on.webp'
        }
        alt=""
        className={showIcon ? 'sound' : 'noOpacity'}
      />
      {/* </div> */}
    </DiaperVideoContainer>
  );
};

export default BabyDiaperVideo;
